import { render, staticRenderFns } from "./PriceListDetail.vue?vue&type=template&id=ca409de0&"
import script from "./PriceListDetail.vue?vue&type=script&lang=js&"
export * from "./PriceListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports